import { cn } from '@/utils/cn'

import type { TableToolbarProps } from '../DataTable.types'

export const TableToolbar: React.FC<TableToolbarProps> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-4 p-4',
        'border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
        className
      )}
    >
      {children}
    </div>
  )
}

// Specialized toolbar sections
export const ToolbarLeft: React.FC<{
  children: React.ReactNode
  className?: string
}> = ({ children, className }) => (
  <div className={cn('flex items-center gap-2', className)}>{children}</div>
)

export const ToolbarRight: React.FC<{
  children: React.ReactNode
  className?: string
}> = ({ children, className }) => (
  <div className={cn('flex items-center gap-2', className)}>{children}</div>
)

export const ToolbarCenter: React.FC<{
  children: React.ReactNode
  className?: string
}> = ({ children, className }) => (
  <div className={cn('flex-1 flex items-center justify-center gap-2', className)}>{children}</div>
)

// Responsive toolbar that stacks on mobile
export const ResponsiveToolbar: React.FC<{
  left?: React.ReactNode
  center?: React.ReactNode
  right?: React.ReactNode
  className?: string
}> = ({ left, center, right, className }) => (
  <div
    className={cn(
      'flex flex-col gap-4 p-4',
      'sm:flex-row sm:items-center sm:justify-between',
      'border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
      className
    )}
  >
    {/* Mobile: Stack vertically */}
    <div className="flex flex-col gap-3 sm:hidden">
      {left && <div className="flex items-center gap-2">{left}</div>}
      {center && <div className="flex items-center justify-center gap-2">{center}</div>}
      {right && <div className="flex items-center justify-end gap-2">{right}</div>}
    </div>

    {/* Desktop: Horizontal layout */}
    <div className="hidden sm:flex sm:items-center sm:justify-between sm:w-full sm:gap-4">
      {left && <div className="flex items-center gap-2">{left}</div>}
      {center && <div className="flex-1 flex items-center justify-center gap-2">{center}</div>}
      {right && <div className="flex items-center gap-2">{right}</div>}
    </div>
  </div>
)
